import { Alert, Grid } from "@mui/material";
import { useContext, useEffect } from 'react';
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { SistemaTipo } from "../../../../types/enum/enum";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import OperacionLepLimitesTabla from "./components/OperacionLEPLimitesTabla";
import SeccionLEPDatosOperacion from "./components/SeccionLEPDatosOperacion";
import { useOperacionLEP } from "./hooks/useOperacionLEP";
import { OperacionLEP } from "./types/types";

interface SistemaLEPContentProps {
    operacion: OperacionLEP,
    codSistema: number,
}

const SistemaLEPContent = ({ operacion, codSistema }: SistemaLEPContentProps) => {

    return (
        <>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <SeccionLEPDatosOperacion
                        operacion={operacion}
                    />


                </Grid>
                <Grid item xs={12}>
                    <OperacionLepLimitesTabla
                        operacion={operacion}
                        codSistema={codSistema}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <SeccionFirmas
                            codSistema={SistemaTipo.LEP}
                            idOperacion={operacion.id}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

function SistemaLep() {
    const { idOperacion, codSistema } = useContext<ContextOperacionType>(ContextOperacion)

    const { status, operacion,  } = useOperacionLEP(idOperacion)

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status])


    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    else {

        if (!operacion) {
            return (
                <></>
            )
        }
    }

    return (
        <SistemaLEPContent
            operacion={operacion}
            codSistema={codSistema}
        />
    )
}

export default SistemaLep;
